// App Configuration Constants
export const APP_CONFIG = {
  name: 'TOPPED',
  version: '1.0.0',
  description: 'Plataforma de Comercio Electrónico Moderna',
} as const;

// API Configuration
export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),
  storageURL: process.env.REACT_APP_STORAGE_URL || 'http://localhost:8000',
} as const;

// Helper to get full image URL
export const getImageUrl = (path: string | null | undefined): string => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  return `${API_CONFIG.storageURL}${path}`;
};

// Feature Flags
export const FEATURE_FLAGS = {
  enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  enableDebug: process.env.REACT_APP_ENABLE_DEBUG === 'true',
} as const;

// UI Constants
export const UI_CONSTANTS = {
  maxProductsPerPage: 12,
  animationDuration: 300,
  debounceDelay: 500,
} as const;

// Routes
export const ROUTES = {
  home: '/',
  profile: '/profile',
  cart: '/cart',
  wishlist: '/wishlist',
  products: '/products/:id',
  checkout: '/checkout',
  paymentSuccess: '/payment/success',
  paymentError: '/payment/error',
  admin: '/admin',
  adminProducts: '/admin/products',
  adminCollections: '/admin/collections',
  adminCustomers: '/admin/customers',
  adminOrders: '/admin/orders',
  adminShipping: '/admin/shipping',
  adminSettings: '/admin/settings',
} as const;

// Order Statuses
export const ORDER_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
} as const;

export const ORDER_STATUS_LABELS = {
  [ORDER_STATUS.PENDING]: 'Pendiente',
  [ORDER_STATUS.PROCESSING]: 'Procesando',
  [ORDER_STATUS.SHIPPED]: 'Enviado',
  [ORDER_STATUS.DELIVERED]: 'Entregado',
  [ORDER_STATUS.CANCELLED]: 'Cancelado',
} as const;

export const ORDER_STATUS_COLORS = {
  [ORDER_STATUS.PENDING]: 'bg-yellow-100 text-yellow-800',
  [ORDER_STATUS.PROCESSING]: 'bg-blue-100 text-blue-800',
  [ORDER_STATUS.SHIPPED]: 'bg-indigo-100 text-indigo-800',
  [ORDER_STATUS.DELIVERED]: 'bg-green-100 text-green-800',
  [ORDER_STATUS.CANCELLED]: 'bg-red-100 text-red-800',
} as const;
